import { OWExtension } from './ow-extension';
import { OWExtensions } from './ow-extensions';

// -----------------------------------------------------------------------------
export class OWPlugin {
  private readonly _manifestName: string;
  private _pluginInstance: any = null;

  // ---------------------------------------------------------------------------
  public static async create(manifestName: string): Promise<OWPlugin> {
    const pluginInstance = await OWExtensions.getExtraObject(manifestName);
    return new OWPlugin(pluginInstance);
  }

  // ---------------------------------------------------------------------------
  public get isInitialized(): boolean {
    return this._pluginInstance !== null;
  }

  // ---------------------------------------------------------------------------
  public get instance(): any {
    return this._pluginInstance;
  }

  // ---------------------------------------------------------------------------
  private constructor(pluginInstance: any) {
    this._pluginInstance = pluginInstance;
  }
}
